import styled from "styled-components"

import { TextLink } from "../../../../component-library/design/typography/typography.styles"
import { FONT_SIZE } from "../../../../component-library/design/typography/typography.constants"
import { SPACING } from "../../../../component-library/design/spacing/spacing.constants"
import IconExternalLink from "../../../../assets/external_link.svg"

const InsuranceLink = styled(TextLink)`
  display: inline-block;
  font-size: ${FONT_SIZE.MEDIUM};
  margin-top: ${SPACING.XS};
`

const FlexContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

const StyledExternalLinkIcon = styled(IconExternalLink)`
  margin-left: ${SPACING.XS};
`

export { InsuranceLink, FlexContainer, StyledExternalLinkIcon }
